import React, { useState } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import Privacy from './Privacy'; // 🆕 We will create this file next

function App() {
  const [isAuthorized, setIsAuthorized] = useState(false);

  // 🆕 Check if the user is trying to view the Privacy Policy
  // This allows Google Play reviewers to see the policy without logging in
  const isPrivacyPath = window.location.pathname === '/privacy';

  if (isPrivacyPath) {
    return <Privacy />;
  }

  return (
    <div className="App">
      {!isAuthorized ? (
        <AdminLogin onLoginSuccess={() => setIsAuthorized(true)} />
      ) : (
        <AdminDashboard />
      )}
    </div>
  );
}

export default App;